import React from 'react';
import {Link, useSearchParams} from 'react-router-dom';
import './style.css';
import useLocalization from '../../../Localization';
import {use} from 'react';

const ChapterPageheroText = ({
  heading,
  subheading,
  bgColor,
  pd,
  onScroll,
  chapterTitleName,
  chapterHide,
  chapterFullName,
  handleLanguageSwitch,
  heroLinkText,
  japaneseHeroLinkText,
}) => {
  const {ApplicationString, changeLanguage, currentLanguage} =
    useLocalization();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleScrollToSection = () => {
    localStorage.removeItem('pbssLanguage');
    searchParams.delete('language');
    handleLanguageSwitch(false);
    onScroll();
  };

  const chapterWiseAboutLine = () => {
    if (subheading) {
      return `${ApplicationString['mainLayoutComponent.navbar.aboutPbss']} ${subheading} ${ApplicationString['mainLayoutComponent.navbar.aboutPbss.pbss']}`;
    } else {
      if (chapterFullName === 'Japan') {
        return `About ${chapterTitleName} PBSS`;
      } else {
        return `${ApplicationString['mainLayoutComponent.navbar.aboutPbss']} ${chapterTitleName} ${ApplicationString['mainLayoutComponent.navbar.aboutPbss.pbss']}`;
      }
    }
  };

  const handleJapaneseClick = (e) => {
    e.preventDefault();
    setSearchParams({language: 'ja'});
    changeLanguage('ja');
    handleLanguageSwitch(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <div
        className='hero-text-container'
        style={{background: `${bgColor}`, padding: `${pd}`}}>
        <div className='text-container'>
          <span className='heading'>{heading}</span>
          <span className='subheading'>
            {`${subheading}`} {chapterHide && 'Chapter'}
          </span>
        </div>
        <div className='hero-link-container'>
          <Link to='#' onClick={handleScrollToSection} className='hero-link'>
            {heroLinkText || chapterWiseAboutLine()}
          </Link>
          {chapterFullName === 'Japan' && currentLanguage !== 'ja' && (
            <button
              onClick={handleJapaneseClick}
              className='hero-link'
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: 'blue',
                cursor: 'pointer',
              }}>
              {japaneseHeroLinkText ||
                `${chapterTitleName || 'Japan'} PBSSについて`}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ChapterPageheroText;
